import React from "react";
import "./StepperSteps.scss";
import { ReactComponent as JobsRecommended } from "../../../../../assets/img/jobs-recommended.svg";
import { ReactComponent as JobsDraft } from "../../../../../assets/img/note_stack.svg";
import { ReactComponent as JobsSubmitted } from "../../../../../assets/img/list-check.svg";
import { ReactComponent as JobsArchived } from "../../../../../assets/img/jobs_archive.svg";

const StepperSteps = ({ steps, stepCount, currentStep, onSetCurrentStep, isDesktop, useApplicationTrackingUI }) => {

  const isStepActive = (stepName) => {
    return currentStep.includes(stepName);
  };
  
  const renderSteps = () => {
    return Object.entries(steps).map(([key, value]) => {
      const stepClassName = `stepper-step ${
        isStepActive(key) ? "active" : ""
      }`;
      const stepName = !isDesktop ? value.split(' ')[0] : value;
      return (
        <li key={key} className={stepClassName} role="listitem" onClick={() => onSetCurrentStep([key])}>
          <h6 className="stepper-step-name">{stepName} {stepCount[key] ? (<span>({stepCount[key]})</span>) : null}</h6>
        </li>
      );
    })
  }

  const renderStepsV2 = () => {
    const renderStep = (key, stepName, StepIcon, isActive) => {
      return (
        <li
          key={stepName}
          className={`stepper-step ${isActive ? "active" : ""}`}
          role="listitem"
          onClick={() => onSetCurrentStep([key])}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <StepIcon fill={isActive ? "#004DC9" : "#666"} />
            {isDesktop && (
              <h6 className="stepper-step-name">{stepName}</h6>
            )}
          </div>
          {isDesktop && !!stepCount[key] && (
            <p className={`stepper-step-count ${isActive ? "active" : ""}`}>{stepCount[key] ? (<span>{stepCount[key]}</span>) : null}</p>
          )}
        </li>
      );
    };
    return (
      <>
        {isDesktop && (
          <p className="stepper-heading">RECOMMENDATIONS</p>
        )}
        {renderStep(
          "recommended",
          "Jobs for you",
          JobsRecommended,
          isStepActive("recommended")
        )}
        {isDesktop && (
          <p className="stepper-heading">APPLICATIONS</p>
        )}
        {renderStep("active", "Draft", JobsDraft, isStepActive("active"))}
        {renderStep(
          "submitted",
          "Submitted",
          JobsSubmitted,
          isStepActive("submitted")
        )}
        {renderStep(
          "archived",
          "Archived",
          JobsArchived,
          isStepActive("archived")
        )}
      </>
    );
  };

  return (
    <div className="turing-stepper-wrapper">
      <ul className="turing-stepper" role="list">
        {useApplicationTrackingUI ? renderStepsV2() : renderSteps()}
      </ul>
    </div>
  );
};

export default StepperSteps;
